import { create } from "zustand";

export type TimeZoneMode = "utc" | "local";

const STORAGE_KEY = "timezone";

function readMode(): TimeZoneMode {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "utc" || saved === "local") return saved;
  } catch {
    /* ignore */
  }
  return "utc";
}

function persistMode(mode: TimeZoneMode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}

type TimezoneState = {
  mode: TimeZoneMode;
  setMode: (mode: TimeZoneMode) => void;
};

export const useTimezoneStore = create<TimezoneState>()((set) => ({
  mode: typeof window !== "undefined" ? readMode() : "utc",
  setMode: (mode) => {
    persistMode(mode);
    set({ mode });
  },
}));
